import { useState } from "react";

function useUniqueId(): [number, () => void] {
  const [id, setId] = useState(0);

  const generate = () => {
    setId((prevId) => prevId + 1);
  };

  return [id, generate];
}

export default useUniqueId;
